/** 系统内聚光灯新手引导步骤（全局，与项目无关） */
export const TOUR_STORAGE_KEY = "cloud_spotlight_tour_v1";

export const onboardingSteps = [
  {
    id: "welcome",
    title: "欢迎使用云中控",
    desc: "接下来用几步带你熟悉界面。每步只高亮一个区域，跟着提示操作即可。",
    center: true,
    action: "next",
  },
  {
    id: "aside",
    selector: '[data-tour="aside-menu"]',
    title: "第 1 步 · 功能菜单",
    desc: "左侧是系统功能入口，工程管理、UI 设计、指令库等都在这里切换。",
    placement: "right",
    padding: 6,
    action: "next",
  },
  {
    id: "header",
    selector: '[data-tour="header-actions"]',
    title: "第 2 步 · 顶栏操作",
    desc: "这里可以检查更新、强制刷新缓存，右侧是您的账号菜单。",
    placement: "bottom",
    padding: 8,
    action: "next",
  },
  {
    id: "content",
    selector: '[data-tour="main-content"]',
    title: "第 3 步 · 主工作区",
    desc: "页面主要内容在这里展示，列表、编辑、预览等操作都在这一块完成。",
    placement: "top",
    padding: 10,
    action: "next",
  },
  {
    id: "guide",
    selector: '[data-tour="guide-widget"]',
    title: "第 4 步 · 帮助入口",
    desc: "右下角可随时打开新手引导与在线客服。点击这里试一下，或点「下一步」继续。",
    placement: "left",
    padding: 10,
    action: "click",
    clickHint: "请点击高亮区域继续",
  },
  {
    id: "done",
    title: "引导完成",
    desc: "已经熟悉基本布局了。之后可在右下角「?」里再次打开本引导。",
    center: true,
    action: "finish",
  },
];

export function isTourFinished() {
  try {
    return localStorage.getItem(TOUR_STORAGE_KEY) === "1";
  } catch (e) {
    return false;
  }
}

export function markTourFinished() {
  try {
    localStorage.setItem(TOUR_STORAGE_KEY, "1");
  } catch (e) {
    /* ignore */
  }
}

export function resetTourFinished() {
  try {
    localStorage.removeItem(TOUR_STORAGE_KEY);
  } catch (e) {
    /* ignore */
  }
}
